<div>
  <div class="logo-latam_out">
    <a (click)="back()">
      <img src="assets/images/logo-airlines-blue.svg" alt="Logo da Latam Azul">
    </a>
  </div>

  <div class="container">
    <div class="logo-latam_in">
      <img src="assets/images/logo-airlines-blue.svg" alt="Logo da Latam Azul">
    </div>

    <h5 class="welcome-text">Bem-vindo ao PasseLivre</h5>

    <p class="external-login_text">Login para usuário externos</p>

    <form class="login-form" [formGroup]="loginForm">
      <input type="text" class="anac_code" placeholder="Código ANAC"
        formControlName="user">

        @if (submited && loginForm.controls.user.errors?.required) {
          <app-error-form>
            Informe o Código ANAC.
          </app-error-form>
        }

        <div class="password-container">
          <input #inputPassword class="password" type="password"
            placeholder="CPF" formControlName="password">

            <div class="eye_password">
              <img #iconPassword src="assets/images/eye-view.png"
                alt="Ícone de olho para esconder/mostrar a senha"
                (click)="toogleIconPassword()" />
              </div>
            </div>

            @if (submited && loginForm.controls.password.errors?.required) {
              <app-error-form>
                Informe o CPF.
              </app-error-form>
            }

            <button class="btn-enter" (click)="login()">
              Acessar
            </button>
          </form>
        </div>
      </div>
